import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22index.tsx%22,%22import%22:%22M_PLUS_1p%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22500%22,%22700%22,%22800%22],%22variable%22:%22--font-m-plus-1p%22,%22preload%22:false,%22display%22:%22swap%22}],%22variableName%22:%22mPlus1p%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'M PLUS 1p', 'M PLUS 1p Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
